/** Describes where the insurance is better than the other insurances in the context of a comparison. */
export enum InsuranceAdvantages {
	Cheaper = 'CHEAPER',
	BetterCoverage = 'BETTER_COVERAGE',
}
